import http from "./http";

export interface PackagePayload {
  service_plan_id: number;
  name: string;
  description?: string | null;
  status: string;
  is_visible_to_client?: boolean;
  services?: number[];
}

export interface PackageInclusion {
  id: number;
  package_id: number;
  title: string;
  description?: string | null;
  service_id?: number | null;
  quantity?: number | null;
  frequency?: string | null;
  status: string;
  sort_order: number;
  service?: { id: number; name: string } | null;
}

export interface PackageService {
  id: number;
  name: string;
  description?: string | null;
  category?: string | null;
  status: string;
  is_visible_to_client: boolean;
  default_tasks?: Array<{
    id: number;
    service_id: number;
    title: string;
    instructions?: string | null;
    status: string;
    sort_order: number;
  }>;
}

export interface PackageRecord {
  id: number;
  service_plan_id: number;
  service_plan?: {
    id: number;
    code: string;
    name: string;
  } | null;
  name: string;
  description?: string | null;
  status: string;
  is_visible_to_client: boolean;
  created_at?: string;
  updated_at?: string;
  archived_at?: string | null;
  services?: PackageService[];
  clients?: Array<{
    id: number;
    route_key: string;
    name?: string;
    company_name?: string;
    avatar?: string | null;
  }>;
  inclusions?: PackageInclusion[];
}

export const getPackages = async () => {
  const response = await http.get("/api/packages");
  return response.data;
};

export const getPackageById = async (id: string | number) => {
  const response = await http.get(`/api/packages/${id}`);
  return response.data;
};

export const createPackage = async (payload: PackagePayload) => {
  const response = await http.post("/api/packages", payload);
  return response.data;
};

export const updatePackage = async (
  id: string | number,
  payload: PackagePayload
) => {
  const response = await http.put(`/api/packages/${id}`, payload);
  return response.data;
};

export const archivePackage = async (id: string | number) => {
  const response = await http.post(`/api/packages/${id}/archive`);
  return response.data;
};

export const restorePackage = async (id: string | number) => {
  const response = await http.post(`/api/packages/${id}/restore`);
  return response.data;
};

export const deletePackage = async (id: string | number) => {
  const response = await http.delete(`/api/packages/${id}`);
  return response.data;
};

export interface PackageAssignmentPayload {
  client_id?: number;
  client_ids?: number[];
  package_id: number;
  start_date: string;
  end_date?: string | null;
  status: string;
  is_visible_to_client?: boolean;
  custom_notes?: string;
}

export const assignPackageToClient = async (
  payload: PackageAssignmentPayload
) => {
  const response = await http.post("/api/packages/assign", payload);
  return response.data;
};
